import { Observable } from "rxjs";
import { get } from "../../../service/api";
import { ITokenPair } from "../interface/dto/token-pair";
import { IUserDetailsDto } from "../interface/dto/user-details.dto";

export const getUserDetails = (
    token: ITokenPair,
): Observable<IUserDetailsDto | undefined> =>
    get<IUserDetailsDto>("/auth/me", undefined, token);
